module.exports = __webpack_public_path__ + "static/media/Performance-dashboard-contest-all.44437f45.png";